/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { OktaAuthService } from '@okta/okta-angular';
import {AuthService } from './pages/wpt/auth/auth.service';

@Component({
  selector: 'ngx-app',
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  title = 'okta-app';
  
  constructor(
    private analytics: AnalyticsService,
    public oktaAuth: OktaAuthService,
    public geoAuth: AuthService
  ) 
    {
      // console.log("app construct");
      this.geoAuth.userData.subscribe((data:any) => {
      })
      // // subscribe to authentication state changes
      // this.oktaAuth.$authenticationState.subscribe( data => {
      //   console.log("CHANGE");
      // });
    // else{
      // console.log("[INFO] PAGES NO SUB PAGES")
    // }
  }
  ngOnInit(): void {
    this.analytics.trackPageViews();
    
  }
}
